export default "__VITE_ASSET__d2adb5f0__"